module.exports = __webpack_public_path__ + "68a948759afe2241bf616cdc22dcabec.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/rs.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/rs.svg
// module chunks = 0